import { Filter } from 'labstep-web/constants/filters';

export const filters = [Filter.deleted];
